import React from 'react';
import PickupForm from '../components/PickupForm';
import './SchedulePickup.css';

const SchedulePickup: React.FC = () => {
  return (
    <div className="schedule-pickup">
      <h1>Schedule a Tire Pickup</h1>
      <PickupForm />
    </div>
  );
};

export default SchedulePickup;
